/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import {
    Button,
    Node
} from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IHeaderViewProps } from './farmlands-header';
// @ts-ignore
import { CommonHeader } from '@farmlands/common-components';
import MsDyn365 from '@msdyn365-commerce/core';

import { AEM_URL } from '../../config';

type DeviceType = 'Mobile';

const headerView: React.FC<IHeaderViewProps> = (props) => {
    const {
        AccountSwitchModal,
        RefreshPageModal
    } = props;

    const AccountSwitch = () => AccountSwitchModal;
    const RefreshPage = () => RefreshPageModal;
    // @ts-ignore
    const secondaryNavData = props?.menuBar[0]?.props.config.cmsNavItems;
    const isMobile =
        props.context.request &&
        props.context.request.device &&
        (props.context.request.device.Type as DeviceType) === 'Mobile';

    let searchUrl = '';
    if (!MsDyn365.isBrowser) {
        // return null;
    }
    else {
        if (window.location.hostname.includes('localhost')) {
            searchUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/search?q=`;
        }
        else {
            searchUrl = `${window.location.protocol}//${window.location.hostname}/search?q=`;
        }
    }

    const {
        account,
        wishlist,
        orderDetails
    } = props.context.request.app.routes;

    const signinLinks = [
        {
            label: 'My account',
            path: account.destinationUrl,
            target: '_self'
        },
        {
            label: 'Order history',
            path: orderDetails.destinationUrl,
            target: '_self'
        },
        {
            label: 'Wishlist',
            path: wishlist.destinationUrl,
            target: '_self'
        }
    ];

    return (
        <CommonHeader
            {...props?.headerData}
            items={secondaryNavData.slice()}
            AEM_URL={AEM_URL}
            wishListIconDesktop={props?.wishListIconDesktop}
            wishListIconMobile={props?.wishListIconMobile}
            cartIcon={props?.cartIcon}
            secondaryNavSize={4}
            secondaryNavSource={'ecom'}
            SearchForm={() => _renderReactFragment(props.search)}
            searchUrl={searchUrl}
            SigninButton={() => _renderDesktopAccountBlock(props)}
            AccountSwitchModal={() => AccountSwitch()}
            RefreshPageModal={() => RefreshPage()}
            isMobile={isMobile}
            isAuthenticated={props.context.request.user.isAuthenticated}
            isAuthenticatedMenu={signinLinks}
        />
    );
};

function _renderDesktopAccountBlock(props: IHeaderViewProps): JSX.Element | null {
    const {
        AccountName,
        AccountInfoDropdownParentContainer,
        AccountInfoDropdownPopoverContentContainer,
        accountInfoDropdownButton,
        signOutLink,
        signInLink,
        accountLinksContainer,
        accountLinks,
        toggleAccountModal,
        togglePopover,
        totalAccountLength,
        accountList
    } = props;

    const isSingleAccount = totalAccountLength <= 1;

    if (AccountInfoDropdownParentContainer) {
        if (AccountInfoDropdownPopoverContentContainer) {
            return (
                <>
                    {AccountInfoDropdownPopoverContentContainer.isOpen ? <div className='ms-header__modal-overlay'></div> : null}
                    <Node {...AccountInfoDropdownParentContainer}>
                        {AccountName}
                        {accountInfoDropdownButton}
                        <Node {...AccountInfoDropdownPopoverContentContainer}>
                            {/*tslint:disable-next-line: react-this-binding-issue jsx-no-lambda*/}
                            <div className={`ms-header__account-selector ${isSingleAccount ? 'ms-header__account-selector--hide' : ''}`}>
                                <Button
                                    className={`ms-header__close-popover-button ${
                                        isSingleAccount ? 'ms-header__close-popover-button--white' : ''
                                    }`}
                                    onClick={togglePopover}
                                >
                                    <span className='material-icons-outlined ms-header__close-popover'>close</span>
                                </Button>
                                {!isSingleAccount && (
                                    <>
                                        <span className='material-icons-outlined ms-header__account-icon'>person</span>
                                        <h1 className='ms-header__account-heading'>Select your Account</h1>
                                        {accountList ? accountList.map((list) => list) : false}
                                        {accountList && totalAccountLength > 5 ? (
                                            <div
                                                className='ms-header__more-accounts'
                                                onClick={() => {
                                                    togglePopover();
                                                    toggleAccountModal();
                                                }}
                                            >
                                                See more Accounts
                                            </div>
                                        ) : null}
                                    </>
                                )}
                            </div>
                            <Node {...accountLinksContainer}>
                                <div className='ms-header__account-links'>{accountLinks ? accountLinks.map((link) => link) : false}</div>
                                {signOutLink}
                            </Node>
                        </Node>
                    </Node>
                </>
            );
        } else if (signInLink) {
            return <Node {...AccountInfoDropdownParentContainer}>{signInLink}</Node>;
        }
    }
    props.context.telemetry.error('Header content is empty, module wont render.');
    return null;
}

function _renderReactFragment(items: React.ReactNode[]): JSX.Element | null {
    return (
        <React.Fragment>
            {items && items.length
                ? items.map((slot: React.ReactNode, index: number) => {
                    return <React.Fragment key={index}>{slot}</React.Fragment>;
                })
                : null}
        </React.Fragment>
    );
}

export default headerView;
